import { service } from '@/helpers/http'

const SESSION_KEY = 'teacher_panel_selected_period_id'

const normalizePeriods = (data) => {
    if (Array.isArray(data)) return data
    if (Array.isArray(data?.data)) return data.data
    if (Array.isArray(data?.items)) return data.items
    return []
}

const normalizeResponseData = (response) => {
    if (!response) return null
    if (response.data) return response.data
    return response
}

export const fetchAvailablePeriods = async ({ commit, rootState, dispatch }) => {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
        const access = rootState.auth?.acesso || {}
        const institutionId = access?.instituicao?.id
        const educationalGroupId = access?.grupo?.id
        const currentPeriod = access?.periodo

        let periods = []

        if (institutionId) {
            const payload = {
                institution_id: institutionId,
                educational_group_id: educationalGroupId,
                per_page: 100,
                active: 1
            }
            const response = await dispatch('worktime/ActionGetWorkTimes', payload, { root: true })
            periods = normalizePeriods(normalizeResponseData(response))
        }

        if ((!periods || periods.length === 0) && currentPeriod?.id) {
            periods = [currentPeriod]
        }

        commit('SET_AVAILABLE_PERIODS', periods)
        return periods
    } catch (error) {
        const fallback = rootState.auth?.acesso?.periodo
        const periods = fallback?.id ? [fallback] : []
        commit('SET_AVAILABLE_PERIODS', periods)
        commit('SET_ERROR', 'Não foi possível carregar os períodos disponíveis.')
        return periods
    } finally {
        commit('SET_LOADING', false)
    }
}

export const resolvePeriodContext = async ({ state, dispatch, rootState }, periodIdFromUrl) => {
    const accessPeriod = rootState.auth?.acesso?.periodo
    const storedPeriodId = window.sessionStorage.getItem(SESSION_KEY)
    const targetId = periodIdFromUrl || storedPeriodId || accessPeriod?.id

    if (!targetId) {
        return null
    }

    const periodId = parseInt(targetId, 10)
    if (!periodId) {
        return null
    }

    let selected = state.availablePeriods.find(period => period.id === periodId)

    if (!selected && accessPeriod?.id === periodId) {
        selected = accessPeriod
    }

    if (!selected) {
        try {
            const response = await dispatch('worktime/ActionShowWorkTime', { id: periodId }, { root: true })
            const data = normalizeResponseData(response)
            if (data?.id) selected = data
        } catch (error) {
            selected = null
        }
    }

    if (!selected) {
        return null
    }

    await dispatch('setPeriod', selected)
    return selected
}

export const setPeriod = async ({ commit, rootState, dispatch }, period) => {
    if (!period?.id) return

    commit('SET_SWITCHING', true)
    commit('SET_ERROR', null)

    try {
        const access = rootState.auth?.acesso || {}
        const inferredGroupId = access?.grupo?.id || period?.educational_group_id || period?.educationalGroup?.id || null
        const inferredInstitutionId = access?.instituicao?.id || period?.institution_id || period?.institution?.id || null

        const nextAccess = {
            ...access,
            grupo: access?.grupo?.id ? access.grupo : (inferredGroupId ? { id: inferredGroupId } : access?.grupo),
            instituicao: access?.instituicao?.id ? access.instituicao : (inferredInstitutionId ? { id: inferredInstitutionId } : access?.instituicao),
            periodo: period
        }

        await dispatch('auth/ActionSetAcesso', nextAccess, { root: true })

        window.sessionStorage.setItem(SESSION_KEY, String(period.id))
        commit('SET_SELECTED_PERIOD', period)

        await dispatch('auth/ActionSetTeacherPeriod', { work_time_id: period.id }, { root: true })
    } catch (error) {
        commit('SET_ERROR', 'Não foi possível atualizar o contexto de período.')
    } finally {
        commit('SET_SWITCHING', false)
    }
}

export const clearPeriodContext = ({ commit }) => {
    window.sessionStorage.removeItem(SESSION_KEY)
    commit('SET_SELECTED_PERIOD', null)
}

export const fetchCardSettings = async ({ commit }) => {
    try {
        const response = await service({
            module: 'teacherPanelCardSettings',
            action: 'getCardSettings',
        })
        return response.data || []
    } catch {
        return []
    }
}

export const fetchActivePopups = async ({ commit }) => {
    try {
        const response = await service({
            module: 'teacherPanelCardSettings',
            action: 'getActivePopups',
        })
        return response.data || []
    } catch {
        return []
    }
}

export const markPopupAsRead = async ({ commit }, popupId) => {
    try {
        await service({
            module: 'teacherPanelCardSettings',
            action: 'markPopupAsRead',
            params: { id: popupId },
        })
    } catch {
        // Silenciar - não bloquear UX por falha no registro de leitura
    }
}

